import './style.scss';
import React, { useContext, useMemo } from 'react';
import { renderCurrentDate, renderTime } from '../../../utils/date';
import { isSameDay } from 'date-fns';
import classnames from 'classnames';
import CurrentTimeContext from '../../../context/TimeContext';

function BookList() {
  const { currentDate, bookings, currentBook, currentPage, setCurrentPage, fetchRanges } =
    useContext(CurrentTimeContext);

  const objToday = useMemo(() => {
    const { dayOfWeek, dayOfMonth, curMonth } = renderCurrentDate(fetchRanges.startRange, true);
    return { dayOfWeek, dayOfMonth, curMonth };
  }, [currentDate, fetchRanges.startRange]);

  return (
    <div className="bookListLayout">
      <strong className="dateTitle">
        <button onClick={() => (currentPage ? setCurrentPage(currentPage - 1) : null)}>
          <img
            src={process.env.PUBLIC_URL + (parseInt(currentPage) !== 0 ? '/next_arr_active.svg' : '/next_arr_grey.svg')}
            alt=""
          />
        </button>
        {isSameDay(currentDate, fetchRanges.startRange) && <span>today,</span>}
        <span>{objToday.dayOfWeek},</span>
        <span>{objToday.curMonth}</span>
        <span>{objToday.dayOfMonth}</span>
        <button onClick={() => setCurrentPage(currentPage + 1)}>
          <img src={process.env.PUBLIC_URL + '/next_arr_active.svg'} alt="" />
        </button>
      </strong>
      <section className="sectionBookingItems">
        {bookings.map((book, i) => {
          return (
            <div
              className={classnames('bookingItem', {
                bgGreenMini: book.isEmpty,
                activeSlot: i === currentBook.index,
                isBusy: !currentBook.book?.isEmpty,
              })}
              key={i}
            >
              <div className="bookingItemContainer">
                <p>
                  {renderTime(book.startTime)}
                  <img src={process.env.PUBLIC_URL + '/arrow.svg'} alt="" /> {renderTime(book.endTime)}
                </p>
                <span>{book.isEmpty ? 'Book now' : `${book?.user?.firstName} ${book?.user?.lastName}`}</span>
              </div>
            </div>
          );
        })}
      </section>
    </div>
  );
}

export default BookList;
